import React from 'react'
import ReactDOM from 'react-dom'
import { App } from './App'
import './App.css'
import { LoaderStore } from './Stores/LoaderStore'
import { AppStore } from './Stores/AppStore'
import { ConfigService } from './Services/ConfigService'
import { AuthService } from './Services/AuthService'
import { LanguageService } from './Services/LanguageService';

const rootEl = document.getElementById('root')
export const loaderStore = new LoaderStore()
export const config = ConfigService.getConfig()
export const authService = new AuthService()
export const languageService = new LanguageService()
export const appStore = new AppStore()

const renderCallback = async () => {
  const loader = document.getElementById('react-app-loader')
  if (loader) {
    loaderStore.appLoaderElement = loader
    loader.addEventListener('transitionend', () => {
      if (loader.classList.contains('hide')) {
        loader.classList.add('invisible')
      }
    }, true)
    await languageService.init()
    await authService.init()
    loaderStore.hideAppLoader(true)
  }
}

window.addEventListener('load', async () => {
  if (navigator.serviceWorker) {
    try {
      const reg = await navigator.serviceWorker.register('./sw.js')
      console.log('SW:Registration successful with scope: ', reg.scope)
    } catch (e) {
      console.log('SW:Registration failed: ', e)
    }
  }
})

ReactDOM.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>,
  rootEl,
  renderCallback,
)